import { PageHeader } from "@/components/PageHeader";
import { PageShell } from "@/components/PageShell";
import { getActionMutationOptions } from "@/setup/frontend/api/getActionMutationOptions";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router";

import { useEffect } from "react";
export default function ClientFilesReportPage() {
	const queryClient = useQueryClient();
	const { id, fileId } = useParams();

	const [url, setUrl] = useState<string | undefined>(undefined);
	const options = getActionMutationOptions("getClientFileDownloadLink", {});
	const mutation = useMutation({
		...options,
		mutationFn: ({ id }) =>
			options.mutationFn!({ id, inline: true }).then((res) => {
				return res;
			}),
		onSuccess: (data) => {
			setUrl(data.url);
		},
	});

	useEffect(() => {
		mutation.mutate({ id: Number(fileId) });
	}, [fileId]);

	return (
		<PageShell
			header={
				<PageHeader
					title="Client File Preview"
					breadcrumbs={[
						{
							href: `/clients/${id}/profile`,
							title: "Client",
						},
						{
							href: `/clients/${id}/files/${fileId}`,
							title: "Client File",
						},
					]}
				/>
			}
		>
			{url?.includes(".pdf") ? (
				<iframe
					src={url}
					title="Client File Preview"
					style={{ width: "100%", height: "100%" }}
				/>
			) : (
				<img
					src={url}
					alt="Client File Preview"
					style={{
						width: "100%",
						height: "100%",
						border: "none",
						objectFit: "contain",
					}}
				/>
			)}
		</PageShell>
	);
}
